import { ISeoPageInfoTranslation } from '../endpoints/useGetLayoutUrlResolver';

/**
 * Wybiera tłumaczenie dla danego języka z tablicy tłumaczeń
 * 
 * @param translations - tablica tłumaczeń z backendu (np. [{language: "pl", translation: "Tekst..."}])
 * @param language - kod języka dla którego szukamy tłumaczenia (np. "pl", "en")
 * @returns wartość tłumaczenia (string) lub null jeśli nie znaleziono
 * 
 * @example
 * const translations = [
 *   {language: "pl", translation: "Tytuł po polsku"},
 *   {language: "en", translation: "Title in English"}
 * ];
 * getTranslationByLanguage(translations, "pl") // zwróci "Tytuł po polsku"
 * getTranslationByLanguage(translations, "en") // zwróci "Title in English"
 * getTranslationByLanguage(translations, "de") // zwróci null
 */
export const getTranslationByLanguage = (
  translations: ISeoPageInfoTranslation[] | undefined,
  language: string
): string | null => {
  // Jeśli nie ma tablicy lub jest pusta, zwróć null
  if (!translations || translations.length === 0) {
    return null;
  }

  if (!Array.isArray(translations)) {
    return null;
  }


  // Znajdź tłumaczenie dla danego języka
  const translation = translations.find((t) => t.language === language);
  
  // Zwróć wartość tłumaczenia lub null jeśli nie znaleziono
  return translation?.translation || null;
};
